import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Legacy /member/login route — unified login lives at /login.
 */
function MemberLogin() {
  return <Navigate to="/login" replace />;
}

export default MemberLogin;
